(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('HighChartsService', HighChartsService);

  function HighChartsService(){

    var baseOptions = {
      title: false,
      credits: {
        enabled: false
      },
      plotOptions: {
        series: {
          animation: false,
          states: {
            hover: {
              enabled: false
            }
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          }
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        enabled: false
      },
      chart: {
        styledMode: true,
        animation: false
      }
    };

    return {
      getBaseOptions: getBaseOptions
    };

    function getBaseOptions() {
      return baseOptions;
    }
  }

})();